module.exports = __webpack_public_path__ + "img/biopsy-dr-vagon.9b605494.png";